import { oddsText } from "@/lib/prefs";
import { Trash2 } from "lucide-react";
import { MARKET_LABEL, evText, lineText, pct } from "./valueFormat";
import { Num, PickProgress, PlayerIdentity, UpdatedBadge, matchup, teamLogo } from "./ValuePickRow";

export const VIEWS = ["table", "cards", "markets"];

export function ViewSwitch({ view, onChange }) {
  return (
    <div className="vs-seg" data-testid="value-views">
      {VIEWS.map((v) => (
        <button key={v} type="button" className={view === v ? "is-active" : ""} onClick={() => onChange(v)} data-testid={`value-view-${v}`}>{v}</button>
      ))}
    </div>
  );
}

const Del = ({ p, onDelete }) => onDelete
  ? <button type="button" className="vs-del" onClick={() => onDelete(p.id)} aria-label="Remove pick" data-testid={`value-card-delete-${p.id}`}><Trash2 size={13} /></button>
  : <span />;


const groupBy = (picks, key) => {
  const m = new Map();
  picks.forEach((p) => { const k = key(p); if (!m.has(k)) m.set(k, []); m.get(k).push(p); });
  return [...m.entries()];
};

function CardPick({ p, onDelete }) {
  return (
    <div className={`vs-cpick ${p.outcome ? `is-${p.outcome}` : ""}`} data-testid={`value-card-pick-${p.id}`} data-outcome={p.outcome || ""}>
      <div className="vs-cpick-head">
        <div className="vs-line"><b>{lineText(p)}</b><small>@ {oddsText(p.odds)}</small></div>
        <span className="vs-ev">{evText(p.ev)}</span>
        <Del p={p} onDelete={onDelete} />
      </div>
      <div className="vs-cpick-nums">
        <Num label="PROJ" value={p.proj} />
        <Num label="CHANCE" value={pct(p.p)} />
        <Num label="FAIR" value={oddsText(p.fair_odds)} />
      </div>
      <PickProgress pick={p} />
    </div>
  );
}

// One card per player per game; picks arrive sorted by EV so cards follow their best pick.
export function ValueCards({ picks, onDelete }) {
  return (
    <div className="vs-cards" data-testid="value-cards">
      {groupBy(picks, (p) => `${p.game_id}:${p.player_id}`).map(([k, ps], i) => (
        <article className={`vs-card ${i === 0 ? "is-top" : ""}`} key={k} data-testid={`value-card-${ps[0].game_id}-${ps[0].player_id}`}>
          <header>
            <span className="vs-rank">{i + 1}</span>
            <PlayerIdentity pick={ps[0]} size="lg" />
            <span className="vs-count">{ps.length} {ps.length === 1 ? "pick" : "picks"}</span>
          </header>
          {ps.map((p) => <CardPick key={p.id} p={p} onDelete={onDelete} />)}
        </article>
      ))}
    </div>
  );
}

export function ValueMarkets({ picks, onDelete }) {
  return (
    <div className="vs-mview" data-testid="value-markets-view">
      {groupBy(picks, (p) => p.market).map(([m, ps]) => (
        <details key={m} open className="vs-card vs-mgroup" data-testid={`value-market-group-${m}`}>
          <summary><b>{MARKET_LABEL[m] || m}</b><span className="vs-count">{ps.length} {ps.length === 1 ? "pick" : "picks"}</span></summary>
          <div className="vs-mvrow vs-mvhead"><span>Player</span><span>Line</span><span>Odds</span><span>Proj</span><span>Chance</span><span>Fair</span><span>EV</span><span /></div>
          {ps.map((p) => (
            <div className={`vs-mvrow ${p.outcome ? `is-${p.outcome}` : ""}`} key={p.id} data-testid={`value-market-row-${p.id}`} data-outcome={p.outcome || ""}>
              <div className="vs-mvwho">
                <div className="vs-portrait">{p.photo && <img src={p.photo} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />}</div>
                <div><b>{p.player_name}</b><small><img src={teamLogo(p.team)} alt="" />{p.team} · {matchup(p)}</small><UpdatedBadge pick={p} /></div>
              </div>
              <b className="vs-mvline">{lineText(p).replace(` ${MARKET_LABEL[m] || m}`, "")}</b>
              <span>{oddsText(p.odds)}</span>
              <span>{p.proj}</span>
              <span>{pct(p.p)}</span>
              <span>{oddsText(p.fair_odds)}</span>
              <span className="vs-ev">{evText(p.ev)}</span>
              <Del p={p} onDelete={onDelete} />
              <PickProgress pick={p} />
            </div>
          ))}
        </details>
      ))}
    </div>
  );
}
